import { defineMessages } from '@formatjs/intl';

export default defineMessages({
	heading: {
		id: 'subpage.stress.blog.heading',
		defaultMessage: 'More stress and anxiety resources on our blog.',
		description: 'Heading for a list of blog posts about stress and anxiety.',
	},
});
